import { Outlet, useNavigate, useLocation  } from "react-router-dom";
import { TIME_RELOAD_PAGE, TIME_WAIT_SPINNER } from "../mods/common";

import Footer from "./footer";
import Header from "./header";
import { setDefaultDeferredTime } from "../mods/defer";
import { useEffect, useLayoutEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import SocialButtons from "./socialButtons";
import Services from "../mods/services";

// Register SSE event for soccers
const eventSource = new EventSource((process.env.NODE_ENV === "development") ? "https://localhost:3303/api/sse" : "/api/sse");
eventSource.addEventListener('diff.live', (event) => {
    const diffData = JSON.parse(event.data);
    let isSoccers = window.location.pathname.split('/')[1] === '' || window.location.pathname.split('/')[1] === 'soccer'
    console.log({diffData})

    if (diffData.diff?.length === 0 && diffData.diff[0] !== null) {
        updateTimeLive(diffData?.serverTime)
    }

    if (diffData.diff?.length && diffData.diff[0]) {
        for (let index = 0; index < diffData.diff?.length; index++) {
            const { matchKey, newValue, path } = diffData.diff[index]
            if ((!!newValue?.matchKey) && isSoccers) handleNavigateToCurrentPage();
            handleUpdateItemByMatchKey(matchKey, path, newValue)
        }
    }
});

export const handleUpdateItemByMatchKey = (matchKey: number, path: any, newValue: any) => {
    const updaters = Services.getSoccerUpdaters();
  
    if (updaters[matchKey]) {
        const dynamicPropertyName = path[0];
        let option = {}
  
        if (path.length === 1) {
            option = {
                [dynamicPropertyName]: newValue || '',
            };
        } else {
            if (path[1] === 0) {
                option = {
                    [dynamicPropertyName]: [newValue, updaters[matchKey]?.current()[dynamicPropertyName][1]]
                }
            } else {
                option = {
                    [dynamicPropertyName]: [updaters[matchKey]?.current()[dynamicPropertyName][0], newValue]
                }
            }
        }
  
        const newUpdaters = { ...updaters[matchKey]?.current(), ...option};
        console.log({option});
        console.log({newUpdaters});
        updaters[matchKey]?.setValue(newUpdaters as any)
    }
};
  
export const updateTimeLive = (serverTime: any) => {
    const updaters = Services.getSoccerUpdaters();
    const option = { serverTime }

    for (const [key] of Object.entries(updaters)) {
        const newUpdaters = { ...updaters[key]?.current(), ...option};
        updaters[key]?.setValue(newUpdaters as any)
    }
}

const handleNavigateToCurrentPage = () => {
    window.location.href = window.location.pathname;
};
  
function Layout(props: any) {
    const nav = useNavigate()
    const location = useLocation();
    const [isShowMemu, setIsShowMenu] = useState<boolean>(false)
    let isNews = window.location.pathname.split('/')[1] === 'news'
    let isHighlights = window.location.pathname.split('/')[1] === 'highlights'
    let isSoccers = window.location.pathname.split('/')[1] === '' || window.location.pathname.split('/')[1] === 'soccer'

    useEffect(() => {
        // set first time run here
        setDefaultDeferredTime(TIME_WAIT_SPINNER);
    }, [])

    useLayoutEffect(() => {
        window.scrollTo(0, 0);
      }, [location.pathname]);

    useEffect(() => {
        if (!isNews && !isHighlights && !isSoccers) {
            var interval = setInterval(() => {
                nav(0);
            }, TIME_RELOAD_PAGE);
        }

        return () => clearInterval(interval);
    }, [isNews, isHighlights, isSoccers]);

    const handleShowHideMenu = () => setIsShowMenu(prev=>!prev)
    const handleNavigateToHome = () => nav('/')
    const handleNavigateToAnyPage = (path: string) => nav(path)

    return <>
        <Header isMobile={isShowMemu} navigate={nav} showDownloadApp={false} showFavorites={false} showNews={false} handleShowHideMenu={handleShowHideMenu}></Header>

        <hr className="max-w-screen-xl mx-auto border-primary-darker dark:border-zinc-200  dark:border-zinc-200 mb-5" />

        <div className="max-w-screen-xl min-h-screen mx-auto md:flex lg:grid lg:grid-cols-9 md:gap-x-2 items-start">
            <Outlet context={[isShowMemu,handleShowHideMenu]} />
        </div>

        <Footer navigate={nav}></Footer>

        <div id="bottom-menu" className="!block lg:!hidden bg-main-bg dark:bg-slate-100">
            <div className="flex">
                <button className={`nav-item dark:text-black ${(isNews || isHighlights) ? "" : "active"} mr-4`} onClick={handleNavigateToHome}>
                    {<div className={`active-line ${(isNews || isHighlights) ? "opacity-0" : ""}`}></div>}
                    <div className="flex items-center m-auto">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" className="fill-[#5B6874] dark:fill-black">
                            <path d="M12 2C10.0222 2 8.08879 2.58649 6.4443 3.6853C4.79981 4.78412 3.51809 6.3459 2.76121 8.17317C2.00433 10.0004 1.8063 12.0111 2.19215 13.9509C2.578 15.8907 3.53041 17.6725 4.92894 19.0711C6.32746 20.4696 8.10929 21.422 10.0491 21.8079C11.9889 22.1937 13.9996 21.9957 15.8268 21.2388C17.6541 20.4819 19.2159 19.2002 20.3147 17.5557C21.4135 15.9112 22 13.9778 22 12C22 10.6868 21.7413 9.38642 21.2388 8.17317C20.7363 6.95991 19.9997 5.85752 19.0711 4.92893C18.1425 4.00035 17.0401 3.26375 15.8268 2.7612C14.6136 2.25866 13.3132 2 12 2ZM16.831 11.393L15.031 13.15C14.966 13.2133 14.9174 13.2914 14.8894 13.3776C14.8613 13.4639 14.8547 13.5556 14.87 13.645L15.282 16.05C15.2994 16.1591 15.2863 16.271 15.2442 16.3731C15.202 16.4753 15.1325 16.5639 15.0433 16.629C14.954 16.6942 14.8485 16.7334 14.7383 16.7424C14.6282 16.7514 14.5177 16.7298 14.419 16.68L12.259 15.543C12.1791 15.5011 12.0902 15.4793 12 15.4793C11.9098 15.4793 11.8209 15.5011 11.741 15.543L9.583 16.679C9.4842 16.7294 9.37335 16.7515 9.26277 16.7427C9.15218 16.734 9.04619 16.6947 8.95657 16.6294C8.86695 16.564 8.79721 16.475 8.75509 16.3724C8.71298 16.2698 8.70014 16.1575 8.718 16.048L9.13 13.648C9.14528 13.5587 9.13871 13.467 9.11085 13.3808C9.08299 13.2946 9.03466 13.2165 8.97 13.153L7.17 11.396C7.09549 11.3233 7.04275 11.2312 7.01775 11.1302C6.99274 11.0291 6.99646 10.9231 7.02848 10.824C7.06049 10.7249 7.11954 10.6368 7.19896 10.5695C7.27839 10.5021 7.37503 10.4583 7.478 10.443L9.969 10.08C10.0578 10.0674 10.1423 10.0336 10.2153 9.98137C10.2882 9.92914 10.3475 9.86006 10.388 9.78L11.467 7.591C11.5173 7.49246 11.5938 7.40973 11.6881 7.35195C11.7824 7.29418 11.8909 7.2636 12.0015 7.2636C12.1121 7.2636 12.2206 7.29418 12.3149 7.35195C12.4092 7.40973 12.4857 7.49246 12.536 7.591L13.614 9.78C13.6546 9.86018 13.714 9.92935 13.7872 9.98159C13.8603 10.0338 13.945 10.0676 14.034 10.08L16.524 10.443C16.6263 10.4589 16.7221 10.5029 16.8009 10.5701C16.8796 10.6373 16.9382 10.725 16.97 10.8235C17.0019 10.922 17.0057 11.0274 16.9812 11.1279C16.9566 11.2285 16.9046 11.3202 16.831 11.393Z" />
                        </svg>
                        <span className={`pl-2 ${isHighlights || isNews ? "" : "text-accent"}`}>{props.t('Scores')}</span>
                    </div>
                </button>
                <button className={`nav-item dark:text-black ${!isNews ? "" : "active"} mr-4`} onClick={() => handleNavigateToAnyPage('/news')}>
                    {<div className={`active-line ${isNews ? "" : "opacity-0"}`}></div>}
                    <div className="flex items-center m-auto">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" className="fill-[#5B6874] dark:fill-black mt-1">
                            <path xmlns="http://www.w3.org/2000/svg" d="M17 0c1.657 0 3 1.343 3 3v14c0 1.657-1.343 3-3 3h-14c-1.657 0-3-1.343-3-3v-14c0-1.657 1.343-3 3-3h14zM15.5 15h-11c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h11c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5zM15.5 13h-11c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h11c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5zM15.5 11h-11c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h11c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5zM8 4h-3c-0.552 0-1 0.448-1 1v3c0 0.552 0.448 1 1 1h3c0.552 0 1-0.448 1-1v-3c0-0.552-0.448-1-1-1zM15.5 8h-4c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h4c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5zM8 5v3h-3v-3h3zM15.5 6h-4c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h4c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5zM15.5 4h-4c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h4c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5z"/>
                        </svg>
                        <span className={`pl-2 ${isNews ? "text-accent" : ""}`}>{props.t('News')}</span>
                    </div>
                </button>
                <button className={`nav-item dark:text-black ${isHighlights ? "active" : ""}`} onClick={()=>handleNavigateToAnyPage('/highlights')}>
                    {<div className={`active-line ${isHighlights ? "" : "opacity-0"}`}></div>}
                    <div className="flex items-center">
                        <svg className="fill-[#5B6874] dark:fill-black" height="800px" width="800px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 297 297">
                            <path d="M148.5,0C66.486,0,0,66.486,0,148.5S66.486,297,148.5,297S297,230.514,297,148.5S230.514,0,148.5,0z M202.79,161.734
                            l-78.501,45.322c-2.421,1.398-5.326,2.138-8.083,2.138c-8.752,0-16.039-7.12-16.039-15.872v-90.645
                            c0-8.752,7.287-15.872,16.039-15.872c2.758,0,5.579,0.739,8.001,2.138l78.542,45.322c4.966,2.867,7.951,8.001,7.951,13.734
                            S207.756,158.867,202.79,161.734z"/>
                        </svg>
                        <span className={`pl-2 ${isHighlights ? "text-accent" : ""}`}>{props.t("Highlights")}</span>
                    </div>
                </button>
            </div>
        </div>
        <SocialButtons />

        {(process.env.NODE_ENV === "development") && <div style={{ display: 'none' }} className="w-1 w-2 w-3 w-4 w-5 w-6 w-7 w-8 w-9 w-10 w-11 w-12 w-13 w-14 w-15 h-1 h-2 h-3 h-4 h-5 h-6 h-7 h-8 h-9 h-10 h-11 h-12 h-13 h-14 h-15 ml-1 ml-2 ml-3 ml-4 ml-5 ml-6 ml-7 ml-8 ml-9 ml-10 mr-1 mr-2 mr-3 mr-4 mr-5 mr-6 mr-7 mr-8 mr-9 mr-10 mt-1 mt-2 mt-3 mt-4 mt-5 mt-6 mt-7 mt-8 mt-9 mt-10 mb-1 mb-2 mb-3 mb-4 mb-5 mb-6 mb-7 mb-8 mb-9 mb-10 pl-1 pl-2 pl-3 pl-4 pl-5 pl-6 pl-7 pl-8 pl-9 pl-10 pr-1 pr-2 pr-3 pr-4 pr-5 pr-6 pr-7 pr-8 pr-9 pr-10 pt-1 pt-2 pt-3 pt-4 pt-5 pt-6 pt-7 pt-8 pt-9 pt-10 pb-1 pb-2 pb-3 pb-4 pb-5 pb-6 pb-7 pb-8 pb-9 pb-10 text-main-bg text-main-bg-lighter  text-primary-lighter dark:text-black text-primary text-primary-darker text-accent text-left text-center text-justify text-start text-end text-right grid-cols-1 grid-cols-2 grid-cols-3 grid-cols-4 grid-cols-5 grid-cols-6 grid-cols-7 grid-cols-8 grid-cols-9 grid-cols-10 grid-cols-11 grid-cols-12" />}
    </>
}

export default withTranslation()(Layout);